import React from 'react';
export function TimelineSection() {
  const phases = [{
    id: '01',
    title: 'Model Demand',
    description: "We predict what each retailer's end customers will buy using historical pricing and sales data to enrich our proprietary demand models."
  }, {
    id: '02',
    title: 'Aggregate Supply',
    description: 'We use AI to aggregate fragmented data on wholesale prices and stock availability from across the global supply base.'
  }, {
    id: '03',
    title: 'Model Distribution Costs',
    description: 'We calculate the true cost to move goods from supplier to buyer, including shipping and tariffs.'
  }];
  return <section id="technology" className="bg-[#1a1a1a] text-[#fafafa] py-32 md:py-40 px-7 md:px-40" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <div className="mb-24 max-w-4xl mx-auto px-8" data-id="element-154">
          <p className="text-lg font-bold uppercase tracking-widest text-[#b8d4e8] mb-4 text-left" data-id="element-155">
            How It Works
          </p>
          <h2 className="text-4xl md:text-6xl font-light leading-tight text-center" data-id="element-156">
            Pimlico Models Demand and Finds the Best Supply to Meet It
          </h2>
        </div>

        <div className="space-y-20 md:space-y-32 relative" data-id="element-157">
          {/* Center Vertical Line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-gradient-to-b from-[#b8d4e8]/40 via-[#b8d4e8]/20 to-transparent" data-id="element-158" />

          {phases.map((phase, index) => {
          const isEven = index % 2 === 0;
          return <div key={phase.id} className={`relative flex items-center ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-159">
                {/* Desktop Content - hidden on mobile */}
                <div className={`hidden md:block w-full md:w-1/2 ${isEven ? 'md:pr-16' : 'md:pl-16'}`} data-id="element-160">
                  <div className={`${isEven ? 'md:text-right' : 'md:text-left'}`} data-id="element-161">
                    <p className="text-lg font-mono text-[#b8d4e8] mb-3 tracking-widest" data-id="element-162">
                      PHASE {phase.id}
                    </p>
                    <h3 className="text-3xl md:text-4xl font-semibold mb-5 text-white leading-tight" data-id="element-163">
                      {phase.title}
                    </h3>
                    <p className="text-gray-400 text-lg leading-relaxed" data-id="element-164">
                      {phase.description}
                    </p>
                  </div>
                </div>

                {/* Center Dot Indicator */}
                <div className="hidden md:flex absolute left-1/2 top-0 -translate-x-1/2 w-10 h-10 bg-[#b8d4e8] items-center justify-center z-10 shadow-lg shadow-[#b8d4e8]/20" data-id="element-165">
                  <span className="text-sm font-bold text-[#1a1a1a]" data-id="element-166">
                    {phase.id}
                  </span>
                </div>

                {/* Empty space on the other side */}
                <div className="hidden md:block w-1/2" data-id="element-167" />

                {/* Mobile: Left-aligned with dot */}
                <div className="md:hidden absolute left-0 top-1 w-8 h-8 bg-[#b8d4e8] flex items-center justify-center z-10 shadow-lg shadow-[#b8d4e8]/20" data-id="element-168">
                  <span className="text-xs font-bold text-[#1a1a1a]" data-id="element-169">
                    {phase.id}
                  </span>
                </div>
                <div className="md:hidden absolute left-4 top-0 bottom-0 w-px bg-gradient-to-b from-[#b8d4e8]/40 via-[#b8d4e8]/20 to-transparent" data-id="element-170" />
                <div className="md:hidden pl-14 w-full" data-id="element-171">
                  <p className="text-xs font-mono text-[#b8d4e8] mb-3 tracking-widest" data-id="element-172">
                    PHASE {phase.id}
                  </p>
                  <h3 className="text-3xl font-semibold mb-5 text-white leading-tight" data-id="element-173">
                    {phase.title}
                  </h3>
                  <p className="text-gray-400 text-lg leading-relaxed" data-id="element-174">
                    {phase.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}